export const DEFAULT_LOCALE = 'lt';
export const DEFAULT_ADMIN_LOCALE = 'lt';
export const NO_INFO = '-';
